
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.2 11.667c2.321 0 4.2-1.892 4.2-4.23 0-2.337-1.879-4.229-4.2-4.229S3 5.1 3 7.438c0 2.337 1.879 4.229 4.2 4.229zm2.88 1.208h-.311a5.874 5.874 0 01-2.569.604 5.886 5.886 0 01-2.569-.604H4.32c-2.385 0-4.32 1.948-4.32 4.35v1.087c0 1.001.806 1.813 1.8 1.813h10.8c.994 0 1.8-.812 1.8-1.813v-1.087c0-2.402-1.935-4.35-4.32-4.35zM18 11.667c1.988 0 3.6-1.624 3.6-3.625 0-2.002-1.613-3.625-3.6-3.625-1.988 0-3.6 1.623-3.6 3.625 0 2 1.612 3.625 3.6 3.625zm1.8 1.208h-.143a5.02 5.02 0 01-1.657.302 5.02 5.02 0 01-1.657-.302H16.2c-.765 0-1.47.223-2.089.581a5.547 5.547 0 011.489 3.769v1.45c0 .083-.019.162-.022.242H22.2c.994 0 1.8-.812 1.8-1.813 0-2.337-1.879-4.23-4.2-4.23z","fill":"#11C6FF"}})])
          )
        }
      }
    